import React, { FC } from 'react';
import { StatusChip, StatusChipType } from '@beeline.com/bp-design-system';
import { useStatusChipIntl } from 'src/components/common/StatusChipTranslations/useStatusChipIntl';

interface Props {
  assignable?: boolean;
}

export const JobProfileAssignableChip: FC<Props> = ({ assignable }) => {
  const intl = useStatusChipIntl();

  return (
    <StatusChip
      dataTest="job-profile-assignable-status"
      label={!!assignable ? intl.enabled : intl.disabled}
      type={!!assignable ? StatusChipType.LIGHT_GREEN : StatusChipType.GREY}
    />
  );
};
